<!--
  @Description 模块菜单
  @Date 2021-12-22
  @Author liufu
-->
<template>
  <div class="container">
    <homeHeader title="模块菜单"></homeHeader>
    <div class="main" v-show="isSearch">
      <div class="card">
        <div class="toolbar-dv">
          <toolBarBtn
            :parentData="this"
            :buttonVisible="buttonVisible"
            :moreButtonList="moreButtonList"
            ref="toolBarBtn"
          ></toolBarBtn>
        </div>
        <div class="table-dv">
          <vxe-grid
            border
            resizable
            size="mini"
            :column-config="{ minWidth: '80px' }"
            :columns="tableColumns"
            :height="tableHeight"
            ref="xTable"
            :mouse-config="{ area: true, extension: true }"
            highlight-hover-row
            highlight-current-row
            :keyboard-config="{
              isArrow: true,
              isEnter: true,
              isTab: true,
              enterToTab: true,
              isClip: true
            }"
            :data="tableData"
            :seq-config="{
              startIndex: (tablePage.currentPage - 1) * tablePage.pageSize
            }"
            :pager-config="tablePage"
            @page-change="handlePageChange"
            @cell-dblclick="handleDbClick"
          ></vxe-grid>
        </div>
      </div>
    </div>
    <!-- 明细界面 -->
    <BMenuGroupDetail :parentData="this" :joinID="joinID" @SingleBack="SingleBack" v-if="!isSearch" />
  </div>
</template>

<script>
import BMenuGroupDetail from './BMenuGroupDetail.vue'
export default {
  components: {
    BMenuGroupDetail
  },
  created() {
    this.InitColumn()
  },
  mounted() {
    this.BindData()
  },
  data() {
    return {
      // 分页设置
      tablePage: {
        total: 0,
        currentPage: 1,
        pageSize: 200,
        align: 'right',
        pageSizes: [200, 300, 400, 500],
        layouts: ['Sizes', 'PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'FullJump', 'Total'],
        perfect: true
      },
      tableData: [],
      // 列设置
      tableColumns: [],
      buttonVisible: {
        lock: false, // 锁定按钮是否显示
        save: false, // 锁定按钮是否显示
        unlock: false, // 解锁按钮是否显示
        update: false,
        delete: false,
        sort: false, // 排序按钮是否显示
        search: false, // 查找按钮是否显示
        more: false // 更多按钮是否显示
      },
      // 拓展按钮
      moreButtonList: [],
      // 获取权限
      Authority: this.AuthorityFilter(this.$route.path),
      // 是否为search界面
      isSearch: true,
      // 传给子组件的id
      joinID: 0
    }
  },
  methods: {
    // 获取数据
    async BindData() {
      if (!this.Authority.see) {
        this.$message.error('您没有相关权限！')
        return
      }
      let tableData = []
      this.tableData = []
      const { data: res } = await this.$http.post('/Common/BMenuGroup/list', {
        pageIndex: this.tablePage.currentPage,
        pageSize: this.tablePage.pageSize,
        seeType: this.Authority.seeType
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      tableData = res.data.rows
      this.tablePage.total = res.data.totals
      this.tableData = tableData.map(item => {
        item.isSave = true
        item.isCheck = false
        return item
      })
    },
    // 刷新数据
    refresh() {
      this.BindData()
    },
    // 初始化
    InitColumn() {
      this.tableColumns = [
        {
          type: 'seq',
          width: 50
        },
        {
          field: 'productionType',
          title: '产品类型'
        },
        {
          field: 'productionVersion',
          title: '产品版本'
        },
        {
          field: 'memo',
          title: '备注'
        }
      ]
    },
    add() {
      if (!this.Authority.edit) {
        this.$message.error('您没有相关权限！')
        return
      }
      this.joinID = 0
      this.$nextTick(() => {
        this.isSearch = false
      })
    },
    // 页面函数
    handlePageChange({ currentPage, pageSize }) {
      this.tablePage.currentPage = currentPage
      this.tablePage.pageSize = pageSize
      this.BindData()
    },
    // 双击查看明细数据
    handleDbClick({ row }) {
      this.$refs.xTable.closeTooltip()
      this.joinID = row.id
      this.$nextTick(() => {
        this.isSearch = false
      })
    },
    SingleBack() {
      this.isSearch = true
      // if (!id || id === 0) {
      //   return
      // }
      this.BindData()
    }
  },
  computed: {
    tableHeight() {
      let isSearchForm = this.searchFormVisible
      // 若有查询框，则共有四段 margin 否则只有表格的两段 margin
      let topBottomMargin = 20
      let tableMargin = isSearchForm
        ? this.heightConfig.mainMargin * 4
        : this.heightConfig.mainMargin * 2 + topBottomMargin
      let isToolBar = true
      return this.tableHeightComputed(tableMargin, isSearchForm, isToolBar)
    }
  }
}
</script>

<style lang="less" scoped>
@main-margin: 15px;
.main {
  width: 100%;
  margin: 0 auto;
  height: calc(100vh - @header-height);
  overflow: hidden;
}
.card {
  margin: @main-margin;
  box-shadow: #bebebe 2px 2px 10px;
  border-radius: 10px;
  overflow: hidden;
}
.toolbar-dv {
  padding: 10px;
}

.table-dv {
  padding: @topBottomMargin;
}

.vxe-checkbox {
  width: 15px !important;
}
</style>
